import React, { useContext, useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { useParams } from "react-router-dom"
//CONTEXT
import ProjectContext from "context/projects/projectContext"

//COMPONENTS
import { Box } from "@mui/material"
import { Container } from "reactstrap"
import { RecordPageViewWithoutUserId } from "App"
import BudgetStructure from "components/Budgeting2023/BugdetStructure"
import Loading from "common/Loading"
import Budget2023Context from "context/budget2023/Budget2023Context"
import ModalCallError from "common/modalCallError"

const BudgetingIndex = () => {
  RecordPageViewWithoutUserId()
  const { projectId } = useParams()
  const projectContext = useContext(ProjectContext)
  const { getProject, projectInfo } = projectContext
  const { uncheckAll, modalBudgetingError, setModalBudgetingError } =
    useContext(Budget2023Context)

  useEffect(() => {
    uncheckAll()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Proyecto </title>
        </Helmet>
        <Container fluid>
          {projectInfo?.projectId == projectId ? (
            <BudgetStructure />
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                minHeight: "calc(100dvh - 160px)",
              }}
            >
              <Loading />
            </Box>
          )}
          {modalBudgetingError.isOpen && (
            <ModalCallError
              open={modalBudgetingError.isOpen}
              setOpen={isOpen => {
                setModalBudgetingError({
                  isOpen: isOpen,
                  error: null,
                  location: "",
                })
              }}
              error={modalBudgetingError.error}
              ubicacion={modalBudgetingError.location}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BudgetingIndex
